<template>
  <div class="downloadGuideContainer">
    <div class="fixed download-icon" v-show="!downloadbg" :class="`fixed-${direction}`">
      <img :src="samllImg" alt="" />
      <div class="unfold-btn" @click="samllImgClick"></div>
    </div>
    <div class="fixed download-bg" :class="downloadbg ? 'download-bg-block' : 'download-bg-none'">
      <img class="bg-img" :class="`fixed-${direction}`" src="@/assets/img/UserCenter/download-guide-bg.png" alt="" />
      <img class="close-btn" @click="closeFn" :src="`${$cdn}/0qlmgw/img/gw2/close.png`" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "DownloadGuide",
  data() {
    return {
      direction: "right",
      downloadbg: false,
    };
  },
  computed: {
    samllImg() {
      return require(`@/assets/img/UserCenter/download-small-${this.direction}.png`);
    },
  },
  methods: {
    samllImgClick() {
      this.downloadbg = true;
    },
    closeFn() {
      this.downloadbg = false;
    },
  },
};
</script>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: all 0.8s ease;
}

.fade-enter,
.fade-leave-to {
  transform: translateX(2000px);
  // opacity:0
}

.downloadGuideContainer {
  position: fixed;
  z-index: 99999;
  bottom: 0;

  .fixed {
    position: fixed;
    z-index: 99999;
  }

  .download-icon,
  .download-bg {
    bottom: 24px;

    img {
      display: block;
    }
  }

  .download-icon {
    width: 72px;

    img {
      width: 100%;
    }

    .unfold-btn {
      position: absolute;
      top: 0;
      width: 19px;
      height: 100%;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      cursor: pointer;
    }

    &.fixed-left {
      left: 0;

      .unfold-btn {
        right: 0;
      }
    }

    &.fixed-right {
      right: 0;

      .unfold-btn {
        left: 0;
      }
    }
  }

  .download-bg {
    display: none;
    width: 1228px;
    height: 125px;
    left: 50%;
    transform: translateX(-50%);
    overflow: hidden;

    &.download-bg-block {
      display: block;
      animation-name: example;
      animation-duration: 1s;
    }
    &.download-bg-none {
      // display: block;
      animation-name: exampleout;
      animation-duration: 1s;
      animation-fill-mode: forwards;
    }
    .bg-img {
      width: 100%;
      height: 100%;
      transition: all 0.18s;

      &.direction-left {
        transform: translateX(-100%);
      }

      &.direction-right {
        transform: translateX(100%);
      }

      &.is-visible {
        transform: translateX(0);
        //transition: all 0.18s;
      }
    }

    .close-btn {
      //   display: none;
      position: absolute;
      top: 52px;
      right: 18px;
      width: 17px;
      cursor: pointer;
    }
  }
}

@keyframes example {
  0% {
    left: 160%;
  }
  100% {
    display: none;
    left: 50%;
  }
}
@keyframes exampleout {
  0% {
    left: 50%;
  }
  100% {
    left: 160%;
  }
}
</style>
